<template>
  <div class="groups-page">
    <AlertBar ref="alertBar" />

    <UploadGroupModal
      @updateGroupsList="updateGroupsList"
      @alert="handleAlert"
      ref="modalGroupUpload"
    />

    <v-card class="card" v-if="!importedPageLayout">
      <div class="header">
        <div class="header-title" data-test-header-title>
          <h1>{{ $t('GroupTab.title') }}</h1>
          <HowToBeginAndWatchAVideo videoType="listGroups" short />
        </div>
        <div class="header-subtitle">
          <h3>{{ $t('GroupTab.subtitle') }}</h3>
        </div>
      </div>

      <v-divider></v-divider>

      <div class="table-header">
        <span class="table-header-title">
          {{ $t('GroupTab.tableHeaderTitle') }}
        </span>

        <v-spacer />

        <ItemSelector
          ref="progressType"
          :menuConfig="{
            showTabs: false,
          }"
          :inputConfig="{
            closeOnSelect: true,
            showAvatar: false,
          }"
          :menuOptions="_statusOptions"
          @update:item="handleStatus($event)"
        >
          <template #default="{ focus, selectedItem }">
            <div class="filter-status" v-ripple @click="focus">
              <div class="container">
                <div class="label">
                  {{
                    selectedItem && selectedItem.data.length
                      ? selectedItem.data[0].label
                      : 'Filtrar status'
                  }}
                </div>

                <v-icon class="droparrow" right size="0.625rem">
                  fi fi-br-caret-down
                </v-icon>
              </div>
            </div>
          </template>
        </ItemSelector>
      </div>

      <div v-if="loading">
        <v-skeleton-loader type="table-tbody" data-test-ranking-loading />
      </div>

      <div v-else class="table-holder">
        <DataTable
          id="DataTable"
          :title="$t('GroupTab.tableHeaderTitle')"
          :headers="_headers"
          :hideHeader="true"
          :hideOption="true"
          :hideSearch="true"
          :contentStyle="false"
          :enablePagination="false"
          :items="groups"
          :itemsPerPage="pagination.limit"
          :skeletonLines="pagination.limit"
          @send="handleSend($event)"
          @search="handleSearch($event)"
        >
        </DataTable>

        <div class="pagination">
          <v-btn
            data-test-table-pagination-previous
            v-if="pagination.page > 1"
            x-small
            tile
            icon
            @click="handlePagination(pagination.page - 1)"
          >
            <v-icon size="10">fi fi-br-angle-left</v-icon>
          </v-btn>

          <div class="current">
            <span class="label-pagination"> {{ pagination.page }} </span>
          </div>

          <v-btn
            data-test-table-pagination-next
            v-if="pagination.page < pagination.total"
            x-small
            tile
            icon
            @click="handlePagination(pagination.page + 1)"
          >
            <v-icon size="10">fi fi-br-angle-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>

    <router-view @alert="handleAlert($event)" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getProcessedGroups } from '@/services/groups'
import UploadGroupModal from '@/views/SyncPage/Tabs/DataPage/Tabs/GroupsPage/Partials/UploadGroupModal/UploadGroupModal.vue'

export default {
  name: 'GroupsPage',

  components: {
    UploadGroupModal,
  },

  data() {
    return {
      loading: true,
      pagination: {
        page: 1,
        limit: 20,
        offset: 0,
        total: 0,
      },
      filters: {},
      groups: [],
    }
  },

  created() {
    this.setImportedPageLayout(!!this.$route.params.id)
    this.$root.$on('modalGroupUpload', this.handleUploadModal)
  },

  mounted() {
    this.setCurrentPage('GroupsPage')
    this.setImportedPageLayout(!!this.$route.params.id)
    this.getProcessedGroups()
  },

  watch: {
    importedPageLayout(val) {
      if (!val) this.filters = {}

      this.getProcessedGroups()
    },
  },

  computed: {
    ...mapGetters(['importedPageLayout']),

    _statusOptions() {
      return [
        {
          value: 'status',
          label: 'Status',
          type: 'listview',
          items: [
            {
              id: 'validating',
              label: this.$t('GroupTab.status.validating'),
            },
            {
              id: 'waiting',
              label: this.$t('GroupTab.status.waiting'),
            },
            {
              id: 'rejected',
              label: this.$t('GroupTab.status.rejected'),
            },
            {
              id: 'importing',
              label: this.$t('GroupTab.status.importing'),
            },
            {
              id: 'imported',
              label: this.$t('GroupTab.status.imported'),
            },
            {
              id: 'error',
              label: this.$t('GroupTab.status.error'),
            },
          ],
        },
      ]
    },

    _headers() {
      return [
        {
          text: this.$t('PeopleService.importedFilesTable.headers.filename'),
          value: 'filename',
          type: 'entity-item',
          sortable: true,
        },
        {
          text: this.$t('PeopleService.importedFilesTable.headers.date'),
          value: 'date',
          type: 'text',
          sortable: true,
        },
        {
          text: this.$t(
            'PeopleService.importedFilesTable.headers.peopleAmount'
          ),
          value: 'groupAmount',
          type: 'text',
          sortable: true,
        },
        {
          text: this.$t(
            'PeopleService.importedFilesTable.headers.amountSuccess'
          ),
          value: 'amountSuccess',
          type: 'text',
          sortable: true,
        },
        {
          text: this.$t('PeopleService.importedFilesTable.headers.amountError'),
          value: 'amountError',
          type: 'text',
          sortable: true,
        },
        {
          text: this.$t('PeopleService.importedFilesTable.headers.amountAlert'),
          value: 'amountAlert',
          type: 'text',
          sortable: true,
        },
        {
          text: this.$t('PeopleService.importedFilesTable.headers.status'),
          value: 'status',
          type: 'text-status',
          sortable: true,
        },
        {
          text: this.$t('PeopleService.importedFilesTable.headers.actions'),
          value: 'actions',
          type: 'action-buttons',
          width: '100',
          sortable: false,
        },
      ]
    },
  },

  beforeDestroy() {
    this.$root.$off('modalGroupUpload', this.handleUploadModal)
  },

  methods: {
    ...mapActions(['setImportedPageLayout', 'setCurrentPage']),

    async getProcessedGroups() {
      this.loading = true

      const payload = {
        limit: this.pagination.limit,
        offset: this.pagination.offset,
        ...this.filters,
      }

      await getProcessedGroups(payload)
        .then(({ data, headers }) => {
          this.groups = data.map(el => {
            return {
              ...el,
              filename: { title: el.filename },
              date: this.formatDate(el.date),
              status: {
                label: this.$t(`GroupTab.status.${el.status}`),
                status: this.formatStatus(el.status),
                tooltip: el.importStatusMessage || '',
              },
              actions: ['send'],
            }
          })

          let total = headers['x-count'] / this.pagination.limit
          if (total % 1 !== 0) total = total + 1

          this.pagination.total = Math.trunc(total)
        })
        .finally(() => {
          this.loading = false
        })
    },

    updateGroupsList() {
      this.getProcessedGroups()
    },

    handlePagination(value) {
      this.pagination.page = value
      this.pagination.offset =
        (this.pagination.page - 1) * this.pagination.limit

      this.getProcessedGroups()
    },

    handleAlert(event) {
      const config = {
        messagePrefix: '',
        description: event.message,
        type: event.type,
        hasLeftBorder: false,
        hasFooter: false,
      }

      this.$refs.alertBar.displayAlert(config)
    },

    handleUploadModal() {
      this.$nextTick(() => {
        this.$refs.modalGroupUpload?.handleDialog()
      })
    },

    search() {
      console.log('search')
    },

    handleSend(event) {
      this.$router.push({
        name: 'ImportedGroupsPage',
        params: { id: event.id },
      })
    },

    handleSort({ sortBy: sortField, sortDesc }) {
      const payload = {
        sortBy: sortField.length ? sortField[0] : null,
        sortOrder: sortField.length ? (sortDesc[0] ? 'desc' : 'asc') : null,
      }

      this.filters = {
        ...this.filters,
        ...payload,
      }

      this.getProcessedGroups()
    },

    handleSearch(search) {
      const payload = {
        filename: search.name !== '' ? search.name : null,
      }

      this.filters = {
        ...this.filters,
        ...payload,
      }

      this.getProcessedGroups()
    },

    handleStatus(event) {
      const payload = {
        status: event ? event.id : null,
      }

      this.filters = {
        ...this.filters,
        ...payload,
      }

      this.pagination.page = 1

      this.getProcessedGroups()
    },

    formatStatus(value) {
      const data = {
        validating: 'waiting',
        waiting: 'waiting',
        rejected: 'error',
        importing: 'waiting',
        imported: 'success',
        error: 'error',
      }

      return data[value]
    },

    formatDate(value) {
      let newDate = new Date(value)

      return `${newDate.toLocaleDateString()} ${newDate.toLocaleTimeString()}`
    },
  },
}
</script>

<style
  lang="scss"
  scoped
  src="@/views/SyncPage/Tabs/DataPage/Tabs/PeoplePage/style.scss"
/>
